import React from "react";
import styled from "styled-components/native";
import { Image as ExpoImage } from "expo-image";
import { LoaderProps } from "./types";

const Loader = (props: LoaderProps) => {
  return (
    <Overlay
      backgroundColor={props.backgroundColor}
      opacity={props.opacity}
      topPadding={props.topPadding}
    >
      <LoaderImage
        style={{ zIndex: 9999 }}
        size={props.size}
        source={"http://cdn.vdbapp.com/vdb2/img/loading.gif"}
      />
    </Overlay>
  );
};

const Overlay = styled.View<any>`
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${({ topPadding }: { topPadding: number }) =>
    topPadding !== undefined ? topPadding : 0}px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ backgroundColor }: { backgroundColor: string }) =>
    backgroundColor ? backgroundColor : "rgba(255, 255, 255, 0.0)"};
  z-index: 9999;
  opacity: ${({ opacity }: { opacity: number }) => (opacity ? opacity : 1)};
`;

const LoaderImage = styled(ExpoImage)<any>`
  width: ${({ size }: { size: number }) => (size ? size : 34)}px;
  height: ${({ size }: { size: number }) => (size ? size : 34)}px;
`;

export default Loader;
